export default __webpack_public_path__ + "static/media/Terms.128b3b81.pdf";